import { ConfigurationLabel, ConfigurationLabelValue } from 'src/common/types/ConfigurationTypes';

interface SanitizedConfigurationLabel {
	showAsFilter: boolean;
	label: string;
	displayName: string;
	values: string[];
}

/**
 * Sanitizes and normalizes a configuration label to ensure consistent data structure
 */
export const sanitizeConfigurationLabel = (
	label: ConfigurationLabel
): SanitizedConfigurationLabel => {
	const hasExcludedValue = label.values.some(
		(v) => typeof v === 'object' && v?.excludedFromDashboard === true
	);

	// Normalize values to always be strings, filtering out excluded values and falsy values
	const normalizedValues = label.values.reduce<string[]>((acc, value) => {
		if (value == null) {
			return acc;
		}

		if (typeof value === 'string') {
			acc.push(value);
			return acc;
		}

		// Handle object values - only include if not excluded
		if (typeof value === 'object') {
			const configValue = value as ConfigurationLabelValue;
			if (!configValue.excludedFromDashboard) {
				acc.push(configValue.value);
			}
		}

		return acc;
	}, []);

	return {
		showAsFilter: Boolean(label.showAsFilter) && !hasExcludedValue,
		label: label.label,
		displayName: label.displayName || label.label,
		values: normalizedValues
	};
};
